export enum AuditAction {
  RemoveBooking = "Remove Booking",
  UpdateBooking = 'Update Booking',
  MakeBooking = 'Make Booking',
  SetUnavailable = 'Set Unavailable',
  SetAvailable = 'Set Available',
  SetAvailableAllDay = 'Set Available All Day',
  SetUnavailableAllDay = 'Set Unavailable All Day'
}
